import { useTranslation } from "react-i18next";
import {
  InfoField,
  MetadataSection,
} from "~/molecules/DocumentMetadataSections";
import { formatDate } from "~/helpers/date";
import { type WorkflowDetails } from "~/api/types";

interface Props {
  workflow: WorkflowDetails;
}

export default function WorkflowDates({ workflow }: Props) {
  const { t } = useTranslation();

  const workflowStartedAt = workflow.stepInstances[0]?.createdAt;
  const workflowEndedAt = workflow.documentVersion.publishedAt;

  return (
    <MetadataSection title={t(($) => $.commons.document.reviewDates)}>
      <div className="grid grid-cols-2">
        <InfoField label={t(($) => $.commons.document.reviewFrom)}>
          <span className={workflowStartedAt ? "text-muted-foreground" : ""}>
            {formatDate(workflow.documentVersion.reviewFrom)}
          </span>
        </InfoField>
        <InfoField label={t(($) => $.commons.document.reviewTo)}>
          <span className={workflowEndedAt ? "text-muted-foreground" : ""}>
            {formatDate(workflow.documentVersion.reviewTo)}
          </span>
        </InfoField>
      </div>
    </MetadataSection>
  );
}
